import * as SiteStories from '../Site.stories';
import SiteStatus from './SiteStatus';

export default {
  title: 'Components/Site/SiteDetailsPage/SiteStatus',
  component: SiteStatus,
  parameters: {
    layout: 'centered',
  },
  tags: ['autodocs'],
};

export const ActiveStatusAndH2AIsTrue = {
  args: {
    site: { ...SiteStories.Default.args.siteData, h2a: true },
  },
};

export const InactiveStatusAndH2AIsFalse = {
  args: {
    site: { ...SiteStories.Default.args.siteData, status: 'inactive', h2a: false },
  },
};

export const ReviewStatusAndH2AIsFalse = {
  args: {
    site: { ...SiteStories.Default.args.siteData, status: 'review', h2a: false },
  },
};
